<script>
import { mapActions, mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables'; 

export default {
  props: {
    scheduleId: {
      type: String,
      default: null,
    },
    resetAssigningStaff: {
      type: Function,
      default: () => {},
    }
  },
  data() {
    return {
      selectedStaff: [],
    }
  },
  computed: {
    ...mapGetters('appointments', ['staffList']),
    branchId() {
      return this.$route.params.branchId;
    },
  },
  methods: {
    ...mapActions('appointments', ['fetchStaffList', 'assignStaffSchedule']),

    async handleAssignStaff() {
      const payload = { "schedule_id": this.scheduleId };

      try {
        await Promise.all(this.selectedStaff.map(staff => 
          this.assignStaffSchedule({
            staffId: staff.staff_id,
            payload
          })
        ));
        useAlert(this.$t('BRANCHES.ASSIGN_STAFF_MODAL.SUCCESS_MESSAGE'));
      } catch (err) {
        console.error(err);
        useAlert(err);
      } finally {
        this.fetchStaffList(this.branchId);
        this.resetAssigningStaff();
      }
    }
  },
  async mounted() {
    try {
      await this.fetchStaffList(this.branchId);
      this.selectedStaff = this.staffList.results.filter(staff => 
        staff.schedules.some(item => item.schedule_id === this.scheduleId)
      );
    } catch (err) {
      console.error(err);
      useAlert(err);
    }
  }
}
</script>

<template>
  <div class="p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-lg max-w-md w-full mx-auto">
    <div class="block mb-4">
      <multiselect
        v-model="selectedStaff"
        :options="staffList.results"
        track-by="staff_id"
        label="staff_name"
        multiple
        :close-on-select="false"
        :clear-on-select="false"
        hide-selected
        :placeholder="$t('BRANCHES.ASSIGN_STAFF_MODAL.STAFF_SELECT_PLACEHOLDER')"
        selected-label 
        :select-label="$t('BRANCHES.ASSIGN_STAFF_MODAL.SELECT_ENTER')"
        :deselect-label="$t('BRANCHES.ASSIGN_STAFF_MODAL.DESELECT_ENTER')"
      />
    </div>

    <button 
      @click="handleAssignStaff()"
      class="w-full py-2 mt-2 text-white font-medium rounded-md transition 
      bg-woot-600 hover:bg-woot-700 focus:ring-2 focus:ring-woot-400 focus:outline-none"
    >
    {{ $t('BRANCHES.ASSIGN_STAFF_MODAL.ASSIGN_BUTTON') }}
    </button>
  </div>
</template>
